import { safeDefine } from "../../registration/safe-define.js";
import { CaptionsButtonElement } from "../../ui/captions-button/element.js";
//#region src/define/ui/captions-button.ts
safeDefine(CaptionsButtonElement);
//#endregion

//# sourceMappingURL=captions-button.js.map